import { useCallback, useMemo } from 'react';

import { LayerNames, LayerVisibilityMode } from '@/modules/common/types/layers';
import { useUserPreferencesStore } from '@/modules/userPreferences/store';

import { getLayerVisibilityModePreference } from '../layerTree';
import { LayerServiceFactory } from '../service/LayerServiceFactory';

const isLayerVisibilityMode = (value: unknown): value is LayerVisibilityMode =>
  value === 'auto' || value === 'force_show' || value === 'force_hide';

export const useSyncLayerVisibilityPreferences = () => {
  const layerSvc = useMemo(() => LayerServiceFactory.getInstance().createLayerService(), []);

  return useCallback(() => {
    const visibilityModes = Object.values(LayerNames).reduce<
      Partial<Record<LayerNames, LayerVisibilityMode>>
    >((acc, layerName) => {
      const preference = getLayerVisibilityModePreference(layerName);
      if (!preference) return acc;

      const value = useUserPreferencesStore.getState().getPreference(preference);
      if (isLayerVisibilityMode(value)) acc[layerName] = value;

      return acc;
    }, {});

    layerSvc.loadLayerVisibilityModes(visibilityModes);
  }, [layerSvc]);
};
